import iconeAjudaRapida from '../../assets/img/icone-ajuda-rapida.svg';
import { BaseProps } from '../../common/BaseProps';
import Accordion from '../Accordion/Accordion';
import styles from './AjudaRapida.module.css';

interface Props extends BaseProps {
  scrollOffset?: number;
  titulo?: string;
}

const AjudaRapida: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <img src={iconeAjudaRapida} className={styles.iconeAjudaRapida} alt="Imagem Ajuda Rápida" />
      <Accordion
        id="ajuda-rapida"
        title={props.titulo ? props.titulo : "Ajuda rápida"}
        icon="fa-question-circle"
        scroll
        scrollOffset={props.scrollOffset}
      >
        {props.children}
      </Accordion>
    </div>
  );
};

export default AjudaRapida;
